import React from 'react';
import { Tab } from 'semantic-ui-react';
import { ProfilePhotos } from './ProfilePhotos';
import { Profile } from '../../app/models/profile';
import { observer } from 'mobx-react-lite';
import { ProfileAboutView } from './ProfileAboutView';
import { ProfileFollowings } from './ProfileFollowings';
import { useStore } from '../../app/stores/store';
import { ProfileActivities } from './ProfileActivities';

interface Props {
  profile: Profile;
}

const ProfileContent: React.FC<Props> = observer(({ profile }) => {
  const { profileStore } = useStore();
  const panes = [
    { menuItem: 'About', render: () => <ProfileAboutView bio={profile.bio} /> },
    { menuItem: 'Photos', render: () => <ProfilePhotos profile={profile} /> },
    { menuItem: 'Events', render: () => <ProfileActivities /> },
    {
      menuItem: 'Followers',
      render: () => <ProfileFollowings />,
    },
    {
      menuItem: 'Following',
      render: () => <ProfileFollowings />,
    },
  ];

  return (
    <Tab
      menu={{ fluid: true, vertical: true }}
      menuPosition="right"
      panes={panes}
      onTabChange={(event, data) => {
        const activeIndex = data.activeIndex as number;
        profileStore.setActiveTab(activeIndex);
      }}
    />
  );
});

export { ProfileContent };
